import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL || "http://localhost:3001", // Fallback to localhost if API_URL is not set
  headers: {
    "Content-Type": "application/json",
  },
});

// Optional: Add interceptors for request/response handling
apiClient.interceptors.request.use(
  (config) => {
    // You can add authentication tokens or modify config here
    // For example: config.headers.Authorization = `Bearer ${getToken()}`;
    return config;
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error);
  },
);

apiClient.interceptors.response.use(
  (response) => {
    // Handle successful responses
    return response;
  },
  (error) => {
    // Handle response errors (e.g., 401, 404, 500)
    // You might want to redirect to login on 401, show error messages, etc.
    if (error.response && error.response.status === 401) {
      // Example: Redirect to login
      // window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);

export default apiClient;
